import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import {
    Box, Button, Card, Chip, Container, Dialog, DialogActions, DialogContent,
    DialogTitle, FormControlLabel, Grid, IconButton, Pagination, Switch, Table,
    TableBody, TableCell, TableHead, TableRow, TextField, Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useCallback, useEffect, useMemo, useState } from "react";
import swal from "sweetalert";
import { useLocation, useNavigate } from "react-router-dom";
import BlockchainAutoControl from "../../components/blockchain-auto-control";
import BlockchainBetPressure from "../../components/blockchain-bet-pressure";
import BlockchainAdminActions from "../../components/blockchain-admin-actions";
import BlockchainClassicSummary from "../../components/blockchain-classic-summary";
import BlockchainGameGuideModal from "../../components/BlockchainGameGuideModal";
import XocDiaHeaderNav from "../../components/XocDiaHeaderNav";

const TABLES = [1, 2];
const TABLE_LETTERS = ["A", "B"];
const RESULT_OPTIONS = [
    ["0.0.1.1", "Chẵn · 2 Đỏ 2 Trắng"],
    ["1.0.0.0", "Lẻ · 1 Đỏ 3 Trắng"],
    ["1.1.1.0", "Lẻ · 3 Đỏ 1 Trắng"],
    ["0.0.0.0", "4 Trắng"],
    ["1.1.1.1", "4 Đỏ"]
];
const ODDS_FIELDS = [
    ["chan", "Chẵn"], ["le", "Lẻ"], ["xiu", "Xỉu"], ["tai", "Tài"],
    ["4trang", "4 Trắng"], ["3trang1do", "3 Trắng 1 Đỏ"],
    ["2do2trang", "2 Đỏ 2 Trắng"], ["3do1trang", "3 Đỏ 1 Trắng"],
    ["4do", "4 Đỏ"], ["trang||do", "4 cùng màu"]
];

const translateBetKey = (key) => {
    const map = {
        chan: "Chẵn",
        le: "Lẻ",
        tai: "Tài",
        xiu: "Xỉu",
        "4do": "4 Đỏ",
        "4trang": "4 Trắng",
        "3do1trang": "3 Đỏ 1 Trắng",
        "3trang1do": "3 Trắng 1 Đỏ",
        "2do2trang": "2 Đỏ 2 Trắng",
        "trang||do": "4 cùng màu"
    };
    return map[String(key).toLowerCase()] || key || "—";
};

const money = (value) => Math.floor(Number(value || 0) / 1000).toLocaleString("vi-VN");
const authConfig = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("user") || ""}` } });
const normalizeResult = (value) => String(value || "").trim().split(/[,\.\s|_-]+/).filter((part) => part === "0" || part === "1").join(".");

function ResultDots({ value }) {
    const parts = normalizeResult(value).split(".").filter(Boolean);
    if (parts.length !== 4) return <Chip label="Chưa xổ" size="small" sx={{ fontWeight: 400, borderRadius: "6px" }} />;
    return <Box sx={{ display: "inline-flex", gap: 0.55, alignItems: "center" }}>{parts.map((part, index) => (
        <Box key={index} component="span" sx={{ width: 18, height: 18, borderRadius: "50%", bgcolor: part === "1" ? "#df1829" : "#fff", border: "1px solid #cbd5e1", boxShadow: "0 1px 2px rgba(0,0,0,0.1)" }} />
    ))}</Box>;
}

function SetXDBlockchain60s() {
    const api = process.env.REACT_APP_API_URL || "";
    const location = useLocation();
    const navigate = useNavigate();
    const requestedTable = Number(new URLSearchParams(location.search).get("sanh") || 1);
    const sanh = TABLES.includes(requestedTable) ? requestedTable : 1;
    const letter = TABLE_LETTERS[sanh - 1];
    const [round, setRound] = useState(null);
    const [seconds, setSeconds] = useState(0);
    const [rounds, setRounds] = useState([]);
    const [currentBets, setCurrentBets] = useState([]);
    const [historyRounds, setHistoryRounds] = useState([]);
    const [allBets, setAllBets] = useState([]);
    const [tableConfig, setTableConfig] = useState(null);
    const [configDraft, setConfigDraft] = useState(null);
    const [selectedResult, setSelectedResult] = useState("");
    const [saving, setSaving] = useState(false);
    const [historyOpen, setHistoryOpen] = useState(false);
    const [betsOpen, setBetsOpen] = useState(false);
    const [configOpen, setConfigOpen] = useState(false);
    const [openGuideModal, setOpenGuideModal] = useState(false);
    const [roundPage, setRoundPage] = useState(1);
    const [historyPage, setHistoryPage] = useState(1);
    const [betPage, setBetPage] = useState(1);
    const [roundSearch, setRoundSearch] = useState("");
    const [userSearch, setUserSearch] = useState("");
    const [dateSearch, setDateSearch] = useState("");

    const readTableConfig = useCallback(async () => {
        const response = await axios.get(`${api}/xocdiablockchain60s/tables`);
        const found = (response.data?.data || []).find((item) => Number(item.sanh) === sanh);
        if (found) {
            setTableConfig(found);
            setConfigDraft({ ...found, odds: { ...(found.odds || {}) } });
        }
    }, [api, sanh]);

    const refresh = useCallback(async (includeHistory = false) => {
        try {
            const requests = [
                axios.get(`${api}/xocdiablockchain60s/getadmin?sanh=${sanh}`, authConfig()),
                axios.get(`${api}/xocdiablockchain60s/list30bet?sanh=${sanh}`, authConfig()),
                axios.get(`${api}/xocdiablockchain60s/getcurrent?sanh=${sanh}`, authConfig())
            ];
            if (includeHistory) requests.push(
                axios.get(`${api}/xocdiablockchain60s/getHistoryBet?sanh=${sanh}`),
                axios.get(`${api}/xocdiablockchain60s/getAllBetByAdmin?sanh=${sanh}`, authConfig())
            );
            const responses = await Promise.all(requests);
            const active = responses[0].data?.data || null;
            setRound(active);
            setSeconds(Number(active?.remaining || 0));
            setRounds(responses[1].data?.data || []);
            setCurrentBets(responses[2].data?.data || []);
            if (includeHistory) {
                setHistoryRounds(responses[3].data?.data || []);
                setAllBets(responses[4].data?.data || []);
            }
        } catch (error) {
            console.error("Không thể đồng bộ Xóc Đĩa Blockchain", error);
        }
    }, [api, sanh]);

    useEffect(() => {
        setRound(null);
        setRounds([]);
        setCurrentBets([]);
        setSelectedResult("");
        readTableConfig().catch(() => {});
        refresh(true);
        const timer = window.setInterval(() => refresh(false), 1000);
        return () => window.clearInterval(timer);
    }, [sanh, readTableConfig, refresh]);

    useEffect(() => {
        if (round?.result) setSelectedResult(normalizeResult(round.result));
    }, [round?._id, round?.result]);

    const canEditCurrent = Boolean(round && seconds > Number(tableConfig?.bettingClosesAt || 6) && !round.settledAt);

    const updateCurrentResult = async (targetVal = null) => {
        const resultToSave = targetVal || selectedResult;
        if (!canEditCurrent || !resultToSave) return;
        setSaving(true);
        try {
            const response = await axios.post(`${api}/xocdiablockchain60s/update`, { sanh, id_bet: round._id, result: resultToSave }, authConfig());
            if (response.data?.success === false) throw new Error(response.data.message);
            setSelectedResult(normalizeResult(resultToSave));
            await refresh(false);
            swal("Thành công", `Đã cập nhật kết quả phiên #${round.id_bet}`, "success");
        } catch (error) {
            swal("Không thể cập nhật", error.response?.data?.message || error.message || "Phiên đã đóng", "error");
        } finally { setSaving(false); }
    };

    const handlePresetFuture = async (item, value) => {
        setSaving(true);
        try {
            const response = await axios.post(`${api}/xocdiablockchain60s/update`, { sanh, id_bet: item._id, result: value }, authConfig());
            if (response.data?.success === false) throw new Error(response.data.message);
            await refresh(false);
            swal("Thành công", `Đã cài trước kết quả phiên #${item.id_bet}`, "success");
        } catch (error) {
            swal("Không thể cài trước", error.response?.data?.message || error.message || "Có lỗi xảy ra", "error");
        } finally { setSaving(false); }
    };

    const saveTable = async () => {
        if (!configDraft) return;
        setSaving(true);
        try {
            const payload = {
                enabled: Boolean(configDraft.enabled),
                minBet: Number(configDraft.minBet), maxBet: Number(configDraft.maxBet),
                odds: Object.fromEntries(Object.entries(configDraft.odds || {}).map(([key, value]) => [key, Number(value)]))
            };
            const response = await axios.put(`${api}/xocdiablockchain60s/table/${sanh}`, payload, authConfig());
            if (response.data?.success === false) throw new Error(response.data.message);
            setTableConfig(response.data.data);
            setConfigOpen(false);
            swal("Thành công", `Đã lưu cấu hình bàn ${letter}`, "success");
        } catch (error) {
            swal("Không thể lưu", error.response?.data?.message || error.message, "error");
        } finally { setSaving(false); }
    };

    const uniqueRounds = useMemo(() => {
        if (!Array.isArray(rounds)) return [];
        const seen = new Set();
        const list = [];

        if (round && (round.id_bet || round._id)) {
            const activeKey = String(round.id_bet || round._id);
            seen.add(activeKey);
            list.push(round);
        }

        for (const item of rounds) {
            const key = String(item.id_bet || item._id);
            if (!seen.has(key)) {
                seen.add(key);
                list.push(item);
            }
        }

        const currentId = Number(round?.id_bet || 0);

        const futureOrCurrent = list
            .filter(a => Number(a.id_bet || 0) >= currentId)
            .sort((a, b) => Number(a.id_bet || 0) - Number(b.id_bet || 0));

        const past = list
            .filter(a => Number(a.id_bet || 0) < currentId)
            .sort((a, b) => Number(b.id_bet || 0) - Number(a.id_bet || 0));

        return [...futureOrCurrent, ...past];
    }, [rounds, round]);

    const filteredRounds = useMemo(() => historyRounds.filter((item) => String(item.id_bet || "").includes(roundSearch)), [historyRounds, roundSearch]);
    
    const formatDateYYYYMMDD = (d) => {
        if (!d) return "";
        const dateObj = new Date(d);
        if (isNaN(dateObj.getTime())) return "";
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const day = String(dateObj.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const filteredBets = useMemo(() => allBets.filter((item) => {
        const matchUser = !userSearch || String(item.user?.username || "").toLowerCase().includes(userSearch.toLowerCase().trim());
        let matchDate = true;
        if (dateSearch) {
            const itemDate = formatDateYYYYMMDD(item.createdAt);
            matchDate = itemDate === searchDate;
        }
        return matchUser && matchDate;
    }), [allBets, userSearch, dateSearch]);
    const betTotal = currentBets.reduce((sum, item) => sum + Number(item.money || 0), 0);

    return <ThemeProvider theme={theme}><DashboardLayout>
        <Box component="main" className="blockchain-admin-page happy-classic-game happy-classic-xocdia" sx={{ flexGrow: 1, py: 3, px: { xs: 1, sm: 2 }, bgcolor: "#f8fafc", minHeight: "100vh" }}><Container maxWidth="xl">
            <div className="classic-game-guide"><button onClick={() => setOpenGuideModal(true)}>Hướng dẫn <span>?</span></button></div>
            <XocDiaHeaderNav currentMode="xdblockchain60s" currentSanh={sanh} />

            <BlockchainAdminActions 
                onConfig={() => { setConfigDraft({ ...tableConfig, odds: { ...(tableConfig?.odds || {}) } }); setConfigOpen(true); }} 
                onRoundHistory={() => { refresh(true); setHistoryOpen(true); }} 
                onBetHistory={() => { refresh(true); setBetsOpen(true); }} 
            />
            <BlockchainAutoControl game="xocdia" />
            <Grid className="classic-round-grid" container spacing={2.5} sx={{ mb: 3 }}>
                <Grid className="classic-round-main" item xs={12} md={8}>
                    <Card sx={{ p: 2.5, height: "100%", borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.04)" }}>
                        <Typography>Kỳ sổ: <Box component="span">{round?.id_bet || "Đang tải..."}</Box></Typography>
                        <Typography>Thời gian: <Box component="span">00:{String(seconds).padStart(2, "0")}</Box></Typography>
                    </Card>
                </Grid>
                <Grid className="classic-round-config" item xs={12} md={4}>
                    <Card sx={{ p: 2.5, height: "100%", borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.04)" }}>
                        <Typography sx={{ fontWeight: 500, fontSize: 15, color: "#0f172a" }}>Cấu hình đang áp dụng</Typography>
                        <Typography sx={{ mt: 1, color: "#475569", fontSize: 14, fontWeight: 300 }}>Trạng thái: <strong style={{ color: tableConfig?.enabled ? "#10b981" : "#ef4444", fontWeight: 500 }}>{tableConfig?.enabled ? "Đang mở" : "Bảo trì"}</strong></Typography>
                        <Typography sx={{ mt: 0.5, color: "#475569", fontSize: 14, fontWeight: 300 }}>Giới hạn cược: <strong style={{ color: "#0f172a", fontWeight: 500 }}>{money(tableConfig?.minBet)} – {money(tableConfig?.maxBet)}</strong></Typography>
                    </Card>
                </Grid>
            </Grid>

            <Card className="classic-active-editor" sx={{ p: 2.5, mb: 3, borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.04)" }}>
                <Typography variant="h6" sx={{ mb: 1.5, fontWeight: 500, fontSize: 16, color: "#0f172a" }}>Chọn kết quả phiên đang chạy</Typography>
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
                    {RESULT_OPTIONS.map(([value, label]) => <Button key={value} disabled={!canEditCurrent || saving} variant={selectedResult === value ? "contained" : "outlined"} onClick={() => updateCurrentResult(value)} sx={{ textTransform: "none", borderRadius: "8px", fontWeight: 400 }}>{label}</Button>)}
                    <Button color="error" variant="contained" disabled={!canEditCurrent || saving || !selectedResult} onClick={() => updateCurrentResult()} sx={{ textTransform: "none", borderRadius: "8px", fontWeight: 400 }}>Cập nhật phiên hiện tại</Button>
                </Box>
                <Box sx={{ mt: 2, display: "flex", gap: 1, alignItems: "center" }}><ResultDots value={selectedResult} /><Typography color="text.secondary" sx={{ fontSize: 13, fontWeight: 300 }}>{canEditCurrent ? `Có thể sửa trong ${Math.max(0, seconds - Number(tableConfig?.bettingClosesAt || 6))} giây nữa` : "Kết quả đã khóa khi bắt đầu mở thưởng"}</Typography></Box>
            </Card>

            <BlockchainClassicSummary game="xocdia" bets={currentBets} />

            <Card className="classic-current-bets-hidden" sx={{ p: 2.5, mb: 3, borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.04)", overflowX: "auto" }}>
                <Typography variant="h6" sx={{ mb: 1.5, fontWeight: 500, fontSize: 16, color: "#0f172a" }}>Cược của người chơi trong phiên hiện tại</Typography>
                <Table size="small"><TableHead><TableRow><TableCell>Người chơi</TableCell><TableCell>Cửa cược</TableCell><TableCell>Tiền cược</TableCell><TableCell>Trạng thái</TableCell><TableCell>Thời gian</TableCell></TableRow></TableHead><TableBody>
                    {currentBets.length ? currentBets.map((item) => <TableRow key={item._id}><TableCell sx={{ fontWeight: 400, color: "#2563eb" }}>{item.user?.username || "-"}</TableCell><TableCell><Chip size="small" label={translateBetKey(item.state)} color="primary" variant="outlined" sx={{ fontWeight: 400, borderRadius: "6px" }} /></TableCell><TableCell sx={{ color: "#d97706", fontWeight: 400 }}>{money(item.money)}</TableCell><TableCell>{item.status_bet}</TableCell><TableCell>{new Date(item.createdAt).toLocaleTimeString("vi-VN")}</TableCell></TableRow>) : <TableRow><TableCell colSpan={5} align="center" sx={{ py: 3, color: "#64748b", fontWeight: 300 }}>Chưa có cược ở phiên này</TableCell></TableRow>}
                </TableBody></Table>
            </Card>

            <Card className="classic-result-table" sx={{ p: 2.5, borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.04)", overflowX: "auto" }}>
                <Typography variant="h6" sx={{ mb: 1.5, fontWeight: 500, fontSize: 16, color: "#0f172a" }}>Các phiên gần nhất</Typography>
                <Table size="small"><TableHead><TableRow><TableCell>Phiên</TableCell><TableCell>Kết quả</TableCell><TableCell>Cập nhật</TableCell></TableRow></TableHead><TableBody>
                    {uniqueRounds.slice((roundPage - 1) * 10, roundPage * 10).map((item) => {
                        const isCurrent = String(item.id_bet || item._id) === String(round?.id_bet || round?._id);
                        const isSettled = Boolean(item.settledAt);
                        const canEdit = !isSettled;
                        const itemResult = normalizeResult(item.result);
                        return <TableRow key={item._id || item.id_bet} sx={{ bgcolor: isCurrent ? "#eff6ff" : isSettled ? "#f9fafb" : undefined }}>
                            <TableCell sx={{ fontWeight: isCurrent ? 600 : 400, color: isCurrent ? "#2563eb" : "inherit" }}>
                                {item.id_bet} {isCurrent ? "(Đang chạy)" : ""}
                                {!isCurrent && isSettled && <Chip size="small" label="Đã khóa" sx={{ ml: 1, bgcolor: "#94a3b8", color: "#fff", fontWeight: 500, borderRadius: "6px" }} />}
                            </TableCell>
                            <TableCell><ResultDots value={item.result} /></TableCell>
                            <TableCell>
                                {isSettled && !isCurrent ? (
                                    <Chip size="small" label="Đã khóa" sx={{ bgcolor: "#e2e8f0", color: "#64748b", fontWeight: 500, borderRadius: "6px" }} />
                                ) : (
                                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                                    {RESULT_OPTIONS.map(([value, label]) => {
                                        let currentVal = isCurrent ? selectedResult : itemResult;
                                        // Normalize currentVal (count number of 1s to match value format)
                                        const count1s = String(currentVal).split('.').filter(x => x === '1').length;
                                        let mappedVal = "";
                                        if (count1s === 4) mappedVal = "1.1.1.1";
                                        else if (count1s === 3) mappedVal = "1.1.1.0";
                                        else if (count1s === 2) mappedVal = "0.0.1.1";
                                        else if (count1s === 1) mappedVal = "1.0.0.0";
                                        else if (count1s === 0 && currentVal) mappedVal = "0.0.0.0";
                                        
                                        const isActive = (mappedVal && mappedVal === value);
                                        return <Button key={value} disabled={!canEdit || saving} variant={isActive ? "contained" : "outlined"} onClick={() => { if (isCurrent) { updateCurrentResult(value); } else { handlePresetFuture(item, value); } }} size="small" sx={{ textTransform: "none", borderRadius: "6px", fontSize: "12px", fontWeight: isActive ? 700 : 400, boxShadow: isActive ? "0 0 8px rgba(220,38,38,0.4)" : "none", bgcolor: isActive ? "#dc2626 !important" : "#ffffff !important", color: isActive ? "#ffffff !important" : "#475569 !important", border: isActive ? "1.5px solid #dc2626 !important" : "1px solid #cbd5e1 !important", "&:hover": { bgcolor: isActive ? "#b91c1c !important" : "#f1f5f9 !important" } }}>{label}</Button>;
                                    })}
                                    {isCurrent && <Button disabled={!canEditCurrent || saving || !selectedResult} variant="contained" color="warning" size="small" onClick={() => updateCurrentResult()} sx={{ textTransform: "none", borderRadius: "6px", fontSize: "12px" }}>Cập nhật</Button>}
                                </Box>
                                )}
                            </TableCell>
                        </TableRow>;
                    })}
                </TableBody></Table>
                <Pagination sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }} page={roundPage} onChange={(_, value) => setRoundPage(value)} count={Math.max(1, Math.ceil(uniqueRounds.length / 10))} color="primary" size="small" />
            </Card>
        </Container></Box>

        <Dialog className="blockchain-data-dialog" open={configOpen} onClose={() => setConfigOpen(false)} maxWidth="md" fullWidth>
            <DialogTitle sx={{ fontWeight: 400 }}>Cấu hình Xóc Đĩa Blockchain {letter}<IconButton onClick={() => setConfigOpen(false)} sx={{ position: "absolute", right: 10, top: 10 }}><CloseIcon /></IconButton></DialogTitle>
            <DialogContent dividers>{configDraft && <><FormControlLabel control={<Switch checked={Boolean(configDraft.enabled)} onChange={(event) => setConfigDraft({ ...configDraft, enabled: event.target.checked })} color="primary" />} label="Bàn hoạt động" /><Grid container spacing={2} sx={{ mt: .5 }}>
                <Grid item xs={6}><TextField fullWidth type="number" label="Cược tối thiểu (điểm)" value={configDraft.minBet} onChange={(event) => setConfigDraft({ ...configDraft, minBet: event.target.value })} /></Grid>
                <Grid item xs={6}><TextField fullWidth type="number" label="Cược tối đa (điểm)" value={configDraft.maxBet} onChange={(event) => setConfigDraft({ ...configDraft, maxBet: event.target.value })} /></Grid>
                {ODDS_FIELDS.map(([key, label]) => <Grid item xs={6} md={4} key={key}><TextField fullWidth type="number" label={`Tỷ lệ ${label}`} value={configDraft.odds?.[key] ?? ""} onChange={(event) => setConfigDraft({ ...configDraft, odds: { ...configDraft.odds, [key]: event.target.value } })} /></Grid>)}
            </Grid></>}</DialogContent><DialogActions><Button onClick={() => setConfigOpen(false)} sx={{ textTransform: "none" }}>Hủy</Button><Button variant="contained" disabled={saving} onClick={saveTable} sx={{ textTransform: "none", borderRadius: "8px" }}>Lưu cấu hình</Button></DialogActions>
        </Dialog>
        <Dialog className="blockchain-data-dialog" open={historyOpen} onClose={() => setHistoryOpen(false)} maxWidth="lg" fullWidth>
            <DialogTitle sx={{ fontWeight: 400 }}>Lịch sử phiên bàn {letter}<IconButton onClick={() => setHistoryOpen(false)} sx={{ position: "absolute", right: 10, top: 10 }}><CloseIcon /></IconButton></DialogTitle><DialogContent dividers>
                <TextField size="small" label="Tìm phiên" value={roundSearch} onChange={(event) => setRoundSearch(event.target.value)} sx={{ mb: 2 }} />
                <Table size="small"><TableHead><TableRow><TableCell>Phiên</TableCell><TableCell>Kết quả</TableCell><TableCell>Tổng cược</TableCell><TableCell>Tổng trả</TableCell><TableCell>Thời gian</TableCell></TableRow></TableHead><TableBody>{filteredRounds.slice((historyPage - 1) * 10, historyPage * 10).map((item) => <TableRow key={item._id}><TableCell>#{item.id_bet}</TableCell><TableCell><ResultDots value={item.result} /></TableCell><TableCell>{money(item.totalBet)}</TableCell><TableCell>{money(item.totalPay)}</TableCell><TableCell>{new Date(item.createdAt).toLocaleString("vi-VN")}</TableCell></TableRow>)}</TableBody></Table>
                <Pagination sx={{ mt: 2 }} page={historyPage} onChange={(_, value) => setHistoryPage(value)} count={Math.max(1, Math.ceil(filteredRounds.length / 10))} color="primary" size="small" />
            </DialogContent>
        </Dialog>
        <Dialog className="blockchain-data-dialog" open={betsOpen} onClose={() => setBetsOpen(false)} maxWidth="xl" fullWidth>
            <DialogTitle sx={{ fontWeight: 400 }}>Lịch sử đặt cược bàn {letter}<IconButton onClick={() => setBetsOpen(false)} sx={{ position: "absolute", right: 10, top: 10 }}><CloseIcon /></IconButton></DialogTitle>
            <DialogContent dividers>
                <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap", alignItems: "center" }}>
                    <TextField size="small" type="date" label="Khoảng thời gian" value={dateSearch} onChange={(event) => { setDateSearch(event.target.value); setBetPage(1); }} InputLabelProps={{ shrink: true }} sx={{ width: 220 }} />
                    <TextField size="small" placeholder="Tên người chơi" value={userSearch} onChange={(event) => { setUserSearch(event.target.value); setBetPage(1); }} sx={{ flexGrow: 1 }} />
                    <Button variant="contained" onClick={() => setBetPage(1)} sx={{ textTransform: "none", borderRadius: "8px", px: 3, bgcolor: "#2563eb" }}>Tìm kiếm</Button>
                    {(dateSearch || userSearch) && <Button variant="outlined" color="secondary" onClick={() => { setDateSearch(""); setUserSearch(""); setBetPage(1); }} sx={{ textTransform: "none", borderRadius: "8px" }}>Xóa lọc</Button>}
                </Box>
                <Table size="small"><TableHead><TableRow><TableCell>Người chơi</TableCell><TableCell>Phiên</TableCell><TableCell>Cửa</TableCell><TableCell>Cược</TableCell><TableCell>Trả</TableCell><TableCell>Trạng thái</TableCell><TableCell>Thời gian</TableCell></TableRow></TableHead><TableBody>{filteredBets.slice((betPage - 1) * 10, betPage * 10).map((item) => <TableRow key={item._id}><TableCell sx={{ color: "#2563eb" }}>{item.user?.username || "-"}</TableCell><TableCell>#{item.id_bet?.id_bet || "-"}</TableCell><TableCell><Chip size="small" label={translateBetKey(item.state)} color="primary" variant="outlined" sx={{ fontWeight: 400, borderRadius: "6px" }} /></TableCell><TableCell sx={{ color: "#d97706" }}>{money(item.money)}</TableCell><TableCell sx={{ color: "#10b981" }}>{money(item.moneythang)}</TableCell><TableCell>{item.status_bet}</TableCell><TableCell>{new Date(item.createdAt).toLocaleString("vi-VN")}</TableCell></TableRow>)}</TableBody></Table>
                <Pagination sx={{ mt: 2 }} page={betPage} onChange={(_, value) => setBetPage(value)} count={Math.max(1, Math.ceil(filteredBets.length / 10))} color="primary" size="small" />
            </DialogContent>
        </Dialog>
        <BlockchainGameGuideModal open={openGuideModal} onClose={() => setOpenGuideModal(false)} />
    </DashboardLayout></ThemeProvider>;
}

export default SetXDBlockchain60s;
